import { DIRECTION_HORIZONTAL } from '@doveconviene/react-sf-viewer/lib/shared/utils/consts'

export default {
  currentPages: [],
  isLast: false,
  flyerId: null,
  navigatorOpen: false,
  zoomed: false,
  initialized: false,
  numberOfPages: 0,
  viewedPages: [],
  flyerPages: {},
  direction: DIRECTION_HORIZONTAL,
  extrasBase: {
    pageNumbers: [],
    extrasBaseArray: [],
  },
}
